import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const RotateImage = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 22C15.199 22 14.445 21.688 13.879 21.121L10.879 18.121C10.312 17.554 10 16.801 10 16C10 15.199 10.312 14.445 10.879 13.879L13.879 10.879C14.446 10.312 15.199 10 16 10C16.801 10 17.555 10.312 18.121 10.879L21.121 13.879C21.688 14.445 22 15.199 22 16C22 16.801 21.688 17.555 21.121 18.121L18.121 21.121C17.554 21.688 16.801 22 16 22V22ZM16 12C15.733 12 15.482 12.104 15.293 12.293L12.293 15.293C12.104 15.482 12 15.733 12 16C12 16.267 12.104 16.518 12.293 16.707L15.293 19.707C15.482 19.896 15.733 20 16 20C16.267 20 16.518 19.896 16.707 19.707L19.707 16.707C19.896 16.518 20 16.267 20 16C20 15.733 19.896 15.482 19.707 15.293L16.707 12.293C16.518 12.104 16.267 12 16 12Z" />
		<path d="M17 28H16C9.383 28 4 22.617 4 16C4 12.508 5.467 9.265 8 7.007V9C8 9.552 8.448 10 9 10C9.552 10 10 9.552 10 9V5C10 4.448 9.552 4 9 4H5C4.448 4 4 4.448 4 5C4 5.552 4.448 6 5 6H6.152C3.515 8.602 2 12.173 2 16C2 23.72 8.28 30 16 30H17C17.552 30 18 29.552 18 29C18 28.448 17.552 28 17 28Z" />
		<path d="M27 26H25.848C28.485 23.398 30 19.827 30 16C30 8.28 23.72 2 16 2H15C14.448 2 14 2.448 14 3C14 3.552 14.448 4 15 4H16C22.617 4 28 9.383 28 16C28 19.492 26.533 22.735 24 24.993V23C24 22.448 23.552 22 23 22C22.448 22 22 22.448 22 23V27C22 27.552 22.448 28 23 28H27C27.552 28 28 27.552 28 27C28 26.448 27.552 26 27 26V26Z" />
	</svg>
);

export default RotateImage;
